import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/images/satellite-internet/fan-fact-shape.png'


const _hoisted_1 = { class: "si-fan-fact-area pb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "si-fan-fact-wrap" }
const _hoisted_4 = { class: "row justify-content-center g-5" }
const _hoisted_5 = ["data-aos-delay"]
const _hoisted_6 = { class: "si-fan-fact-item" }
const _hoisted_7 = { class: "counter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fanFacts, (fact, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "col",
              "data-aos": "fade-up",
              "data-aos-duration": "1000",
              "data-aos-delay": (index + 1) * 100
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h1", null, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(fact.value), 1),
                  _createElementVNode("span", null, _toDisplayString(fact.suffix), 1)
                ]),
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(fact.title) + " ", 1),
                  _createElementVNode("span", null, _toDisplayString(fact.highlight), 1)
                ]),
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "shape" }, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: ""
                  })
                ], -1))
              ])
            ], 8, _hoisted_5))
          }), 128))
        ])
      ])
    ])
  ]))
}